export default "__VITE_ASSET__DZotZcKB__"